module.exports = __webpack_public_path__ + "static/img/T载体克隆banner.1423b4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/T载体克隆banner.jpg
// module id = s7eR
// module chunks = 16